import { Component, input, output } from '@angular/core'
import { PersonaField } from '@app/modules/personas/interfaces/persona-field.interface'

/** Non-persisted visual representation of a field while building a form. */
@Component({
  selector: 'app-form-preview-field',
  standalone: true,
  templateUrl: './form-preview-field.component.html',
  host: {
    class: 'tw-block'
  }
})
export class FormPreviewFieldComponent {
  public readonly field = input.required<PersonaField>()
  public readonly iconClass = input.required<string>()
  public readonly placeholder = input.required<string>()

  public readonly labelChange = output<string>()
  public readonly placeholderChange = output<string>()

  /** Emits the edited label text. */
  public onLabelInput(event: Event): void {
    this.labelChange.emit((event.target as HTMLElement).textContent || '')
  }

  /** Emits the edited placeholder text. */
  public onPlaceholderInput(event: Event): void {
    this.placeholderChange.emit((event.target as HTMLElement).textContent || '')
  }
}
